import React from "react";
import PanelGroupController from "../../components/PanelGroupController";
import {fromJS, Map} from "immutable";
import PropertiesList from "../../components/panels/PropertiesList";
import InlineTable from "../../components/InlineTable";
import Conditional from "../../components/Conditional";
import {formatStatus} from "../../lib/TextFormatter";


const FIELDS = fromJS([
  { field: "trackingNr", title: "Tracking Nr"},
  { field: "type", title: "Last Activity", className: "capitalize"},
  { field: "location", title: "Location"},
])

export default function PropertiesPanel(props) {
  const {
    consignmentAndActivities = Map(),
  } = props;

  let elements = null;
  let activitiesElements = null;

  if (!props.id) {
    elements = <p className="u-no-selection">Nothing selected</p>
  } else {
    let consignmentProperties = fromJS([
      {prop: "consignmentId", label: "Consignment Id", type: "string"},
      {prop: "extOrderId", label: "External Order Id", type: "id"},
      {prop: "warehouseId", label: "Warehouse Id", type: "string"},
      {prop: "service", label: "Service", type: "string"},
      {prop: "cost", label: "Cost", type: "number"},
      {prop: "currency", label: "Currency", type: "string"},
      {prop: "status", label: "Status", type: "string"},
      {prop: "deliveryInstructions", label: "Instructions", type: "string"},
      {prop: "packages", label: "Packages", type: "fn", fn: (data) => [data.get("packages", Map()).map((pack) => pack.get("trackingNr")), "array"]},
      {prop: "recipient", label: "Recipient", type: "fn", fn: (data) => [data.get("recipient"), "shippingAddress"]},
      {prop: "updatedAt", label: "Updated At", type: "utc"},
      {prop: "insertedAt", label: "Inserted At", type: "utc"},
    ])

    const consignment = consignmentAndActivities.get("consignment") || Map();

    elements = (
      <PropertiesList properties={consignmentProperties} data={consignment} />
    );

    let consignmentActivitiesProperties = fromJS([
      {prop: "status", label: "Status", type: "status"},
      {prop: "version", label: "Version", type: "string"},
      {prop: "updatedAt", label: "Updated At", type: "utc"},
      {prop: "insertedAt", label: "Inserted At", type: "utc"},
    ]);

    const consignmentActivities = consignmentAndActivities.get("consignmentActivities") || Map();

    const usedTrackingNrs = {}
    const activities = consignmentActivities.get("activities")
    const lastActivities = activities && activities.filter((activity) => {
      // Activities are already sorted by occuredAtUtc so we can take the
      // first one for each trackingNr
      if (!usedTrackingNrs[activity.get("trackingNr")]) {
        usedTrackingNrs[activity.get("trackingNr")] = true;

        return true;
      }
      
      return false;
    }).map((activity) => activity.set("type", formatType(activity.get("type"))));

    activitiesElements = (
      <>
        <PropertiesList properties={consignmentActivitiesProperties} data={consignmentActivities} />
        <br/>
        <InlineTable
          itemKey="trackingNr"
          data={lastActivities}
          fields={FIELDS}
          dataType="last_activities"
        />
      </>
    )
  }

  return (
    <div>
      <PanelGroupController title="Consignement" expanded={props.expanded}>
        {elements}
      </PanelGroupController>
      <Conditional show={!!props.id}>
        <PanelGroupController title="Consignment Activities" expanded={props.expanded}>
          {activitiesElements}
        </PanelGroupController>
      </Conditional>
    </div>
  );
}

function formatType(type) {
  return formatStatus(type);
}